import { LuShare } from '@react-icons/all-files/lu/LuShare'
import React from 'react'

import Tooltip from 'components/ui/tooltip'

export default function ShareArrowIcon() {
  return (
    <Tooltip content={'Share'}>
      <LuShare size={20} />
    </Tooltip>
  )
}
